import { Button } from "components";
import CriticalPointTable from "components/CriticalPointTable/CriticalPointTable";
import CriticalPeriodModal from "modals/CriticalPeriodModal/CriticalPeriodModal";
import React, { useState } from "react";

const CriticalPointPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className=" w-full mt-5">
      <div className="flex justify-end">
        <Button
          onClick={openModal}
          className="bg-light_blue_800 addCustomerBtn cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 w-[150px]"
        >
          Set Critical period
        </Button>
      </div>
      <CriticalPointTable />

      {isModalOpen && <CriticalPeriodModal closeModal={closeModal} />}
    </div>
  );
};

export default CriticalPointPage;
